module.exports = __webpack_public_path__ + "static/media/ad-logo-snow.6f5fa449.svg";